var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermisos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#f0b841",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 18.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0px",
    d: "m8,0C5.48,0,3.43,2.05,3.43,4.57v2.29c-1.89,0-3.43,1.54-3.43,3.43v4.57c0,1.89,1.54,3.43,3.43,3.43h9.14c1.89,0,3.43-1.54,3.43-3.43v-4.57c0-1.89-1.54-3.43-3.43-3.43v-2.29c0-2.52-2.05-4.57-4.57-4.57Zm5.71,10.29v4.57c0,.63-.51,1.14-1.14,1.14H3.43c-.63,0-1.14-.51-1.14-1.14v-4.57c0-.63.51-1.14,1.14-1.14h9.14c.63,0,1.14.51,1.14,1.14Zm-8-3.43v-2.29c0-1.26,1.02-2.29,2.29-2.29s2.29,1.02,2.29,2.29v2.29h-4.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    strokeWidth: "0px",
    cx: 8,
    cy: 12.57,
    r: 1.14
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermisos);
export default __webpack_public_path__ + "static/media/permisos.dc5e06275b54219665737df7dcf8bfec.svg";
export { ForwardRef as ReactComponent };